import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { Link as RouterLink } from '@confluence/route-manager/entry-points/Link';
import { SPACE_QUESTIONS_NATIVE } from '@confluence/named-routes/entry-points/routes';

interface SpaceLinkProps {
	spaceKey: string;
	spaceName: string;
}

const spaceLinkStyles = css({
	font: token('font.body.small'),
	// haven't found the way to set color for all cases(visited, etc) without important for router link
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	color: `${token('color.text.subtle')} !important`,
});

export const SpaceLink: React.FC<SpaceLinkProps> = ({ spaceKey, spaceName }) => {
	return (
		<RouterLink
			css={spaceLinkStyles}
			name={SPACE_QUESTIONS_NATIVE.name}
			params={{ spaceKey }}
			aria-label={spaceName}
		>
			{spaceName}
		</RouterLink>
	);
};
